var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.93 89.4A40.4 40.4 0 1 1 90.332 49 40.447 40.447 0 0 1 49.93 89.4Zm0-77.8A37.4 37.4 0 1 0 87.332 49 37.444 37.444 0 0 0 49.93 11.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.93 75.417a10.962 10.962 0 0 1-10.95-10.949 1.5 1.5 0 0 1 1.5-1.5h18.9a1.5 1.5 0 0 1 1.5 1.5 10.962 10.962 0 0 1-10.95 10.949Zm-7.808-9.449a7.951 7.951 0 0 0 15.615 0Zm26.651-6.001H31.086a4.9 4.9 0 0 1 0-9.8h1.848V39.578A17 17 0 0 1 50.75 22.6a17.2 17.2 0 0 1 16.175 17.416v10.151h1.848a4.9 4.9 0 1 1 0 9.8Zm-37.687-6.8a1.9 1.9 0 0 0 0 3.8h37.687a1.9 1.9 0 1 0 0-3.8h-3.348a1.5 1.5 0 0 1-1.5-1.5V40.016A14.2 14.2 0 0 0 50.609 25.6a14 14 0 0 0-14.675 13.978v12.089a1.5 1.5 0 0 1-1.5 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.533ff2b2fbc9897b87223a9d15d260da.svg";
export { ForwardRef as ReactComponent };